import { apiClient } from '../../../lib/api/client';

export interface RoleListItem {
  id: string;
  name: string;
  description?: string | null;
  permissionCount: number;
  userCount: number;
}

export interface RoleDetail {
  id: string;
  name: string;
  description?: string | null;
  permissions: string[];
}

export async function getRoles(): Promise<RoleListItem[]> {
  const response = await apiClient.get<RoleListItem[]>('/roles');
  return response.data;
}

export async function getRole(id: string): Promise<RoleDetail> {
  const response = await apiClient.get<RoleDetail>(`/roles/${id}`);
  return response.data;
}

export interface PermissionFeatureCatalogItem {
  featureKey: string;
  label: string;
  permissions: string[];
}

export async function getPermissionCatalog(): Promise<PermissionFeatureCatalogItem[]> {
  const response = await apiClient.get<PermissionFeatureCatalogItem[]>(
    '/roles/permission-catalog'
  );
  return response.data;
}

export async function createRole(payload: {
  name: string;
  description?: string;
  permissions: string[];
}): Promise<{ id: string }> {
  const response = await apiClient.post<{ id: string }>('/roles', payload);
  return response.data;
}

export async function updateRole(
  id: string,
  payload: { name: string; description?: string; permissions: string[] }
): Promise<void> {
  await apiClient.put(`/roles/${id}`, payload);
}

export async function deleteRole(id: string): Promise<void> {
  await apiClient.delete(`/roles/${id}`);
}
